import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import {ERROR_PAGES_404_ROUTE} from '@core/constants/navigation';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminGuard  {
  constructor(private router: Router) { }

  canActivate(): boolean {
    if (localStorage.getItem('isSuperAdmin') === 'true') {
      return true;
    }

    this.router.navigateByUrl(ERROR_PAGES_404_ROUTE);
    return false;
  }
}
